export default "__VITE_ASSET__BOTYAATT__"